const translations: Record<string, string> = {
  "ak_contacts_duty_dispatcher": "Duty dispatcher",
  "ak_contacts_dso_emergency_service": "DSO emergency service",
  "ak_contacts_state_emergency_service": "State Emergency Service",
  "ak_contacts_fire_smoke": "fire, smoke",
  "ak_contacts_police": "Police",
  "ak_contacts_break_in_theft": "break-in, theft",
  "ak_contacts_operations_management": "Operations management",
  "ak_contacts_helios_aggregator_llc": "HELIOS AGGREGATOR LLC",
  "ak_contacts_technical_maintenance": "Technical maintenance",
  "ak_contacts_helios_strategia_llc": "HELIOS STRATEGIA LLC",
  "ak_contacts_trading": "Trading",
  "ak_contacts_tepla_llc": "TEPLA LLC",
  "ak_contacts_aggregating_group": "Aggregating group",
  "ak_contacts_servicing_bank": "Servicing bank",
  "ak_contacts_oschadbank_jsc": "OSCHADBANK JSC",
  "ak_contacts_transmission_system_operator": "Transmission system operator",
  "ak_contacts_npc_ukrenergo": "NPC UKRENERGO",
  "ak_contacts_distribution_system_operator": "Distribution system operator",
  "ak_contacts_zakarpattiaoblenergo_pjsc": "ZAKARPATTIAOBLENERGO PJSC",
  "ak_contacts_market_operator_se": "MARKET OPERATOR SE",
  "ak_contacts_guaranteed_buyer_se": "GUARANTEED BUYER SE",
  "ak_contacts_ministry_of_energy_of_ukraine": "MINISTRY OF ENERGY OF UKRAINE",
  "ak_contacts_neurc": "NEURC",
  "ak_contacts_state_energy_supervision_inspectorate": "STATE ENERGY SUPERVISION INSPECTORATE",
  "ak_contacts_state_emergency_service_2": "STATE EMERGENCY SERVICE",
  "ak_contacts_state_environmental_inspectorate": "STATE ENVIRONMENTAL INSPECTORATE",
  "ak_contacts_number_not_specified": "Number not specified",
  "ak_contacts_contacts": "Contacts",
  "ak_contacts_emergencies": "Emergencies",
  "ak_contacts_24_7": "24/7",
  "ak_contacts_counterparties": "Counterparties",
  "ak_contacts_market": "Market",
  "ak_contacts_state": "State",
  "ak_contacts_helios_strategia": "Helios Strategia",
};

export default translations;
